import { useStaticQuery, graphql } from 'gatsby'

export function useDataHeaderByEn() {
    const data = useStaticQuery(graphql`
        {
            menu: allDatoCmsRenshinMenu(sort: { fields: [sorting], order: ASC }, filter: { locale: { eq: "en" } }) {
                nodes {
                    title
                    url
                    parentSection {
                        title
                    }
                }
            }

            policy: datoCmsRenshinPageOther(title: { eq: "Privacy Policy" }, locale: { eq: "en" }) {
                value
            }

            developer: datoCmsRenshinPageOther(title: { eq: "Developer" }, locale: { eq: "en" }) {
                value
            }

            contactUs: datoCmsRenshinPageOther(title: { eq: "Contact Us" }, locale: { eq: "en" }) {
                value
            }

            languageEn: datoCmsRenshinPageOther(title: { eq: "Language" }, locale: { eq: "en" }) {
                value
            }

            languageHy: datoCmsRenshinPageOther(title: { eq: "Language" }, locale: { eq: "hy" }) {
                value
            }

            fb: datoCmsRenshinSocial(title: { eq: "Facebook" }, locale: { eq: "en" }) {
                title
                url
            }

            linkedin: datoCmsRenshinSocial(title: { eq: "Linkedin" }, locale: { eq: "en" }) {
                title
                url
            }

            inst: datoCmsRenshinSocial(title: { eq: "Instagram" }, locale: { eq: "en" }) {
                title
                url
            }

            YouTube: datoCmsRenshinSocial(title: { eq: "Youtube" }, locale: { eq: "en" }) {
                title
                url
            }
        }
    `)

    return data
}
